module.exports = __webpack_public_path__ + "img/10_reduced_inequalities_color.95e8af7a.svg";